import type { UserPreferencesNotificationsSwitchProps } from "./user-preferences-notifications-switch.type";

import { Flex, Switch, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import { Badge } from "@/ui/badge";

import { useUserPreferencesNotificationsSwitch } from "./user-preferences-notifications-switch.hook";

export const UserPreferencesNotificationsSwitch = (
  props: UserPreferencesNotificationsSwitchProps
) => {
  const { t } = useTranslation();
  const { handleChange, isChecked, isUnsaved } =
    useUserPreferencesNotificationsSwitch(props);

  return (
    <Flex gap="small">
      <Switch onChange={handleChange} checked={isChecked} />
      {isUnsaved && (
        <Tooltip title={t("user:preferences.notifications.unsaved")}>
          <Badge status="info" />
        </Tooltip>
      )}
    </Flex>
  );
};
